import { ProfileConfig } from '@foxcorp/foxkit-profile-js';
import { signOut } from 'State/User';
import { ExtendedProfileSDK } from './ProfileSDKExtended';
import { cookieManager } from './CookieManager';
import { getCookieDomain, getCookieName } from './AuthStore';
import { getAppConfig, initUserState } from 'State/store';

//Helpers related to ProfileSDK

let profile = {};

export const profileSDK = () => {
  if (!Object.keys(profile).length) {
    createProfile();
  }

  return profile;
};

export const mapEnvironment = (env) => {
  switch (env) {
    case 'development':
    case 'qa':
      return 'staging';
    case 'staging':
    case 'production':
      return 'prod';
  }
};

export const createProfile = () => {
  const { identityApiBaseUrl, authClientId, appVersion, appEnv, accountApiKey, deviceIdCookieName } =
    getAppConfig().defaultConfig;

  const config = {
    apiKey: accountApiKey,
    appName: 'fox-nation-commerce',
    appVersion,
    clientId: authClientId,
    isSsr: typeof window === 'undefined',
    environment: mapEnvironment(appEnv), // development, qa, staging, production
    baseUrl: `${identityApiBaseUrl}/v2.0`,
    useEksEndPoints: false,
    statefulRefreshToken: {
      useHydraForRefresh: true,
      cookieManager: cookieManager(),
      authCookieDomain: getCookieDomain(),
      authCookieName: getCookieName(),
      onRefreshSuccess: () => {
        initUserState();
      },
      onRefreshError: (error) => {
        console.error('[ProfileSDK][core] onRefreshError', error);

        if (typeof window !== 'undefined') {
          signOut(true);
        }
      },
      use: true,
    },
    httpClientTimeout: 10000, // the number of milliseconds before an http request times out
  };

  const profileConfig = new ProfileConfig(config);
  profile = new ExtendedProfileSDK(profileConfig, deviceIdCookieName);
};
